import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import * as styles from './AccountSelect.css';
import { ContentLayout } from '../ContentLayout';
import { Account } from './components/Account';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AccountSelect = function AccountSelect(_ref) {
  var accounts = _ref.accounts,
    loadableAccount = _ref.loadableAccount,
    continueByPhoneLoading = _ref.continueByPhoneLoading,
    continueByAccountLoading = _ref.continueByAccountLoading,
    onAccountSelect = _ref.onAccountSelect;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles['wrapper'], _defineProperty({}, styles['wrapper-scroll'], accounts.length >= 4)),
    children: /*#__PURE__*/_jsxs(ContentLayout, {
      children: [accounts.map(function (account) {
        return /*#__PURE__*/_jsx(Account, {
          title: account,
          disabled: continueByAccountLoading || continueByPhoneLoading,
          loading: loadableAccount === account && continueByAccountLoading,
          onClick: function onClick() {
            return onAccountSelect(account);
          }
        }, "account_".concat(account));
      }), /*#__PURE__*/_jsx(Account, {
        onClick: onAccountSelect,
        disabled: continueByPhoneLoading || continueByAccountLoading,
        loading: continueByPhoneLoading,
        title: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443"
      })]
    })
  });
};